import api from "../../services/apis/antecipeApi";
import type { Holiday, HolidayInput, HolidaysQuery } from "./types";

export async function fetchHolidays(q: HolidaysQuery = {}): Promise<Holiday[]> {
  const params: Record<string, string> = {};
  if (q.from) params.from = q.from;
  if (q.to) params.to = q.to;
  if (q.uf) params.uf = q.uf;
  if (q.city) params.city = q.city;
  if (q.includeInactive) params.includeInactive = "true";
  return (await api.get("antecipebackoffice/calendar/holidays", { params })).data.rows;
}

export async function createHoliday(input: HolidayInput): Promise<Holiday> {
  return (await api.post("antecipeadmin/calendar/holidays", input)).data;
}

export async function deactivateHoliday(id: number, reason: string): Promise<Holiday> {
  return (await api.patch(`antecipeadmin/calendar/holidays/${id}/deactivate`, { reason })).data;
}

export async function reactivateHoliday(id: number): Promise<Holiday> {
  return (await api.patch(`antecipeadmin/calendar/holidays/${id}/reactivate`)).data;
}
